import {
  PriceType,
  type Product,
  ProductType,
} from '@wix/ambassador-forms-v4-form/types';
import { generateUUID } from '@wix/form-schema';

import { getProductPrice } from '../../field-settings/settings-shared/products/product-price';
import { type ProductValue } from '../../field-settings/settings-shared/products/types';

export function toProductValue(
  product: Product,
  value: string | undefined,
): ProductValue {
  const price = Number(value || '0');
  return {
    productId: product.id!,
    price:
      product.priceType === PriceType.DYNAMIC_PRICE ? price : String(price),
    quantity: 1,
  };
}

export function findProductWithDynamicPrice(
  products: Product[],
): Product | undefined {
  return products.find(
    (product) => product.priceType === PriceType.DYNAMIC_PRICE,
  );
}

export function aDynamicPriceProduct(): Product {
  return {
    id: generateUUID(),
    priceType: PriceType.DYNAMIC_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: { minimum: 1, maximum: 1 },
    dynamicPriceOptions: { minPrice: '0' },
  };
}

export function aFixedPriceProduct(
  price: number,
  id: string = generateUUID(),
): Product {
  return {
    id,
    priceType: PriceType.FIXED_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: { minimum: 1, maximum: 1 },
    fixedPriceOptions: { price: String(price) },
  };
}

export function excludeProductsWithDynamicPrice(
  products: Product[],
): Product[] {
  return products.filter(
    (product) => product.priceType !== PriceType.DYNAMIC_PRICE,
  );
}

export function getCustomAmount(
  productValue: ProductValue | undefined,
  customAmountProduct: Product | undefined,
): string {
  return productValue?.productId === customAmountProduct?.id
    ? String(productValue?.price ?? '')
    : '';
}

export function getProductValueOnCheckboxChange(
  productId: string,
  productValue: ProductValue | undefined,
  productsById: Record<string, Product>,
): ProductValue[] {
  const newValue =
    productValue?.productId === productId ? undefined : productId;
  const product = newValue ? productsById[newValue] : undefined;
  return product ? [toProductValue(product, getProductPrice(product))] : [];
}
